// extracted by mini-css-extract-plugin
export var section = "Section-module--section--5_-T1";
export var title = "Section-module--title--2SCUt";
export var visible = "Section-module--visible--3WsVH";
export var container = "Section-module--container--dDZIV";